import React, { Component } from 'react';
import { Grid, AppBar, Toolbar, IconButton, Typography, makeStyles } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';

const useStyles = makeStyles({
    root: {
        backgroundColor: '#003A4D'
    }
})

const Layout = (props) => {
    //const classes = useStyles(); 
        return (

            <Grid>
                <Grid container>
                    <AppBar position="static">
                        <Toolbar variant="regular">
                            {/*<IconButton edge="start" color="inherit" aria-label="menu">
                            
                                <MenuIcon />
                            </IconButton> */}
                            <Typography variant="h5" color="inherit">
                                ATKV-DigiProjekte
                            </Typography>
                        </Toolbar>
                    </AppBar>
                    <Grid container justify="center">
                        {props.children}
                    </Grid>
                </Grid>
            </Grid>

        );
   
}

export default Layout;



// WEBPACK FOOTER //
// ./src/components/Layout.js